import { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Label } from '../../components/ui/label';
import { Input } from '../../components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Loader2, Send } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AssignLabCard = ({ orderId, onAssigned }) => {
  const [labs, setLabs] = useState([]);
  const [fabricantId, setFabricantId] = useState('');
  const [deadline, setDeadline] = useState('');
  const [scope, setScope] = useState('complet');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    axios.get(`${API}/organizations?type=fabricant`).then((r) => setLabs(r.data)).catch(() => {});
  }, []);

  const assign = async () => {
    if (!fabricantId) { toast.error('Choisissez un laboratoire'); return; }
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/orders/${orderId}/assign`,
        { fabricant_id: fabricantId, deadline: deadline || null, scope });
      toast.success(`Dossier envoyé à ${data.fabricant_name} — bon de travail généré`);
      onAssigned(data);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erreur d'affectation");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card className="border-indigo-200 bg-indigo-50/40" data-testid="assign-lab-card">
      <CardHeader><CardTitle className="text-base">Affecter à un laboratoire</CardTitle></CardHeader>
      <CardContent className="grid sm:grid-cols-4 gap-3 items-end">
        <div className="sm:col-span-2">
          <Label>Laboratoire</Label>
          <Select value={fabricantId} onValueChange={setFabricantId}>
            <SelectTrigger data-testid="assign-lab-select"><SelectValue placeholder="Choisir..." /></SelectTrigger>
            <SelectContent>
              {labs.map((l) => <SelectItem key={l.id} value={l.id}>{l.name} {l.country ? `(${l.country})` : ''}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label>Date limite labo</Label>
          <Input type="date" value={deadline} onChange={(e) => setDeadline(e.target.value)} data-testid="assign-deadline-input" />
        </div>
        <Button onClick={assign} disabled={busy} className="gap-2" data-testid="assign-submit-btn">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}Envoyer
        </Button>
      </CardContent>
    </Card>
  );
};
